import { render, staticRenderFns } from "./RootBlocks.vue?vue&type=template&id=f97029a0&scoped=true"
import script from "./RootBlocks.vue?vue&type=script&lang=js"
export * from "./RootBlocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97029a0",
  null
  
)

export default component.exports